import { Configuration, RedirectRequest } from "@azure/msal-browser";
import { appConfig } from "utils/config/appConfig";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: appConfig.client_id,
    authority: `https://login.microsoftonline.com/${appConfig.tenant_id}`,
    redirectUri: appConfig.redirect_url,
  },
  cache: {
    cacheLocation: "localStorage",
    // storeAuthStateInCookie: false
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["user.read"],
};
